<dx-popup
    [showTitle]="true"
    title="Settings"
    [dragEnabled]="false"
    [hideOnOutsideClick]="true"
    [showCloseButton]="false"
    [visible]="visible"
    [toolbarItems]="toolbarItems"
    [maxWidth]="500"
    [height]="'auto'"
>   
    <dx-form 
        [formData]="formData"
        >
        <dxi-item
            dataField="machineId"
            editorType="dxSelectBox"
            [isRequired]="true"
            [editorOptions]="{
                dataSource: selectOptions,
                displayExpr: 'name',
                valueExpr: 'id',
                placeholder: 'Select machine'
            }">
        </dxi-item>

        <dxi-item
            dataField="refreshInterval"
            placeholder="Refresh delay (seconds)">
        </dxi-item>
    </dx-form>
</dx-popup>